export default __webpack_public_path__ + "static/media/Facebook.43a111aa.svg";